import errorManager from '@/rollbar.js';

const updatePopupPrint = () => {
  if (document.querySelector('#modal-valutation')) {
    eventBus.$on('fields_changed', (data) => {
      const field = data.find((item) => item.name === 'pai[modify_description]' || item.name === 'guest_valutation[modify_description]');

      if (field) {
        const el = document.querySelector('.js-link-async-report-analisi');
        if (el) {
          el.dataset.guestValutationDescription = field.value;
        }
      }
    });
  }
};

const init = () => {
  try {
    updatePopupPrint();
  } catch (e) {
    errorManager(e);
  }
};

window.valutationPrintUpdate = {
  init,
};
